import { BrowserRouter } from 'react-router-dom';
import Aside from '../Components/Aside/Aside';
// import Modal from '../Components/Modal/Modal';
import SideMenu from '../Components/SideMenu/SideMenu';
import SideMenuContextProvider from '../contexts/SideMenuContextProvider';
import SizeContextProvider from '../contexts/SizeContextProvider';
import Routes from './Routes';
import ScrollToTop from './ScrollToTop';

const App = () => {
    return (
        <BrowserRouter>
            <SideMenuContextProvider>
                <SizeContextProvider>
                    <Aside />
                    <SideMenu />
                    {/* <Modal /> */}
                    <Routes />
                </SizeContextProvider>
            </SideMenuContextProvider>
            <ScrollToTop />
        </BrowserRouter>
    );
};

export default App;
